export default {
  title: "Measurement Units",
  subtitle: "Manage measurement units",
  createTitle: "Create Measurement Unit",
  createSubtitle: "Add a new measurement unit",
  editTitle: "Edit Measurement Unit",
  editSubtitle: "Update measurement unit details",
  
  breadcrumbs: {
    measurementUnits: "Measurement Units",
    create: "Create",
    edit: "Edit"
  },
  
  table: {
    name: "Name",
    symbol: "Symbol",
    type: "Type",
    conversionFactor: "Conversion Factor",
    isDefault: "Default",
    actions: "Actions"
  },
  
  fields: {
    name: "Name",
    symbol: "Symbol",
    type: "Type",
    conversionFactor: "Conversion Factor to Base",
    isDefault: "Set as Default Unit"
  },
  
  types: {
    length: "Length",
    weight: "Weight"
  },
  
  placeholders: {
    name: "Enter unit name (e.g., Kilogram)",
    symbol: "Enter unit symbol (e.g., kg)",
    conversionFactor: "Enter conversion factor to base unit"
  },
  
  validation: {
    nameRequired: "Name is required",
    symbolRequired: "Symbol is required",
    conversionFactorRequired: "Conversion factor must be greater than 0",
    fillAllFields: "Please fill all required fields"
  },
  
  messages: {
    fetchError: "Error fetching measurement units",
    createSuccess: "Measurement unit created successfully",
    createError: "Error creating measurement unit",
    updateSuccess: "Measurement unit updated successfully",
    updateError: "Error updating measurement unit",
    deleteSuccess: "Measurement unit deleted successfully",
    deleteError: "Error deleting measurement unit",
    deleteConfirm: "Are you sure you want to delete this measurement unit?",
    noMeasurementUnits: "No measurement units found",
    loading: "Loading measurement units..."
  },
  
  buttons: {
    create: "Create Unit",
    creating: "Creating...",
    update: "Update Unit",
    updating: "Updating...",
    cancel: "Cancel"
  },
  
  addNew: "Add New Unit",
  
  help: {
    conversionFactor: "Factor to convert this unit to the base unit of the same type. For example, if the base unit for weight is kilogram, then 1 gram = 0.001 kg, so the conversion factor for gram would be 0.001.",
    defaultUnit: "The default unit is used as the base for conversions within the same measurement type."
  }
};
